import { useWarrantyOnlyRedirect } from 'core/hooks/useWarrantyOnlyRedirect';

/**
 * Warranty-only users (e.g. arriving from a shared Firebase password-reset
 * link) are handed off to Avid Warranty instead of entering HomeKeep.
 *
 * Renders nothing. Lives outside Routes on purpose: Routes remounts its whole
 * route tree on every re-render, so it must not subscribe to extra state.
 */
const WarrantyOnlyRedirect: React.FC = () => {
  useWarrantyOnlyRedirect();
  return null;
};

export default WarrantyOnlyRedirect;
